import "../styles/header.css";
import { FaUserCircle, FaShoppingCart, FaWallet, FaSearch } from "react-icons/fa";
import React, { useState, useEffect, useContext, useRef } from "react";
import { Modal, Dropdown } from "antd";
import AuthModal from "../comopnents/AuthModal";
import { useNavigate, NavLink, Link } from "react-router-dom";
import { CartContext } from "../contextApi/CartContext";

const Header = () => {
  const navigate = useNavigate();
  const { setUserId, walletAmount, count } = useContext(CartContext);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [authMode, setAuthMode] = useState("login");
  const [menuOpen, setMenuOpen] = useState(false);
  const [query, setQuery] = useState("");
  const [name, setName] = useState("");
  const [walletModalOpen, setWalletModalOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const navRef = useRef(null);
  const menuToggleRef = useRef(null);

  const getStoredFirstName = () =>
    localStorage.getItem("firstName") ||
    localStorage.getItem("first_name") ||
    localStorage.getItem("name") ||
    "";

  useEffect(() => {
    setName(getStoredFirstName());
  }, []);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 8);

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (!menuOpen) return;
      if (
        navRef.current &&
        !navRef.current.contains(event.target) &&
        menuToggleRef.current &&
        !menuToggleRef.current.contains(event.target)
      ) { 
        setMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [menuOpen]);

  const userType = localStorage.getItem("userType");
  const normalizedUserType = (userType || "").toLowerCase();
  const canUseWallet = ["customer", "dealer", "service center"].includes(normalizedUserType);
  const displayName = name || getStoredFirstName() || "User";
  const role = localStorage.getItem("userType");
  const isLoggedIn = Boolean(localStorage.getItem("token"));

  const formatBadgeCount = (value) => {
    const numericValue = Number(value) || 0;
    return numericValue > 99 ? Number(walletAmount) : numericValue;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!query.trim()) return;
    navigate(`/search?query=${encodeURIComponent(query)}`);
    setMenuOpen(false);
  };

  const items = isLoggedIn
    ? role === "Admin" || role === "SuperAdmin" || role === "Warehouse" || role === "Marketing Manager"
      || role === "Digital Manager" || role === "telecalling" || role === "sales" || role === "Accounts"
      ? [
        {
          key: "admin",
          label: "Admin Panel",
          onClick: () => navigate("/adminsidebar"),
        },
        {
          key: "logout",
          label: "Logout",
          onClick: () => {
            localStorage.clear();
            setUserId("");
            window.location.href = "/";
          },
        },
      ]
      : [
        {
          key: "profile",
          label: "My Profile",
          onClick: () => navigate("/profile"),
        },
        {
          key: "orders",
          label: "Orders",
          onClick: () => navigate("/orders"),
        },
        role === "Service Center" && {
          key: "ServiceHistory",
          label: "Service History",
          onClick: () => navigate("/ServiceHistory"),
        },
        {
          key: "logout",
          label: "Logout",
          onClick: () => {
            localStorage.clear();
            setName("");
            setUserId("");
            window.location.href = "/";
          },
        },
      ].filter(Boolean)
    : [];

  const handleAuthSuccess = () => {
    setShowAuthModal(false);
    setName(getStoredFirstName());
  };

  return (
    <div className="container p-0 header-shell">
      <header className={`main-header ${isScrolled ? "is-scrolled" : ""}`}>
        <div className="logo-section">
          <div className="logo">
            <Link to="/" className="logo-link" aria-label="Pixel home">
              <img
                src="https://pixeltools.in/assets/logo-Dm-Kl2OT.png"
                alt="PIXEL"
                className="logo-img"
              />
            </Link>
          </div>
        </div>

        <button
          type="button"
          className={`menu-toggle ${menuOpen ? "is-open" : ""}`}
          ref={menuToggleRef}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label={menuOpen ? "Close navigation menu" : "Open navigation menu"}
          aria-expanded={menuOpen}
          aria-controls="primary-navigation"
        />

        <nav
          className={`main-nav ${menuOpen ? "active" : ""}`}
          ref={navRef}
          id="primary-navigation"
          aria-label="Primary navigation"
        >
          <ul className="nav-list">
            <li>
              <NavLink to="/" end onClick={() => setMenuOpen(false)}>
                HOME
              </NavLink>
            </li>
            <li>
              <NavLink to="/categories" onClick={() => setMenuOpen(false)}>
                SHOP
              </NavLink>
            </li>
            <li>
              <NavLink to="/warranty" onClick={() => setMenuOpen(false)}>
                WARRANTY
              </NavLink>
            </li>
            <li>
              <NavLink to="/Blogs" onClick={() => setMenuOpen(false)}>
                BLOGS
              </NavLink>
            </li>
            <li>
              <NavLink to="/ContactUs" onClick={() => setMenuOpen(false)}>
                CONTACT
              </NavLink>
            </li>
            <li>
              <NavLink to="/About" onClick={() => setMenuOpen(false)}>
                ABOUT US
              </NavLink>
                {/* <NavLink to="/luckydraw" onClick={() => setMenuOpen(false)}>
                LUCKY DRAW
              </NavLink>
                 <NavLink to="/winner-list" onClick={() => setMenuOpen(false)}> 
               WINNER'SLIST
              </NavLink> */}
            </li>
            {role === "Marketing Manager" && (
              <li className="mobile-dealer-link">
                <NavLink to="/Dealer" onClick={() => setMenuOpen(false)}>
                  BECOME A DEALER
                </NavLink>
              </li>
            )}      
          </ul>
        </nav>

        <div className="header-actions">
          <form onSubmit={handleSubmit} className="search-form" role="search">
            <div className="search-input-wrapper">
              <FaSearch className="search-icon" aria-hidden="true" />
              <input
                type="text"
                placeholder="Search Products"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                aria-label="Search products"
              />
            </div>
          </form>

          {canUseWallet && Number(walletAmount) > 0 && (
            <button
              type="button"
              className="header-icon-button header-wallet-button"
              onClick={() => setWalletModalOpen(true)}
              aria-label={`Open wallet. Balance ${Number(walletAmount || 0).toFixed(2)}`}
            >
              <span className="header-icon-wrap">
                <FaWallet className="header-action-icon" aria-hidden="true" />
                <span className="header-badge" aria-hidden="true">
                  {formatBadgeCount(walletAmount)}
                </span>
              </span>
            </button>
          )}

          <Dropdown menu={{ items }} trigger={["click"]}>
            <button
              type="button"
              className="icon user-info"
              onClick={() => {
                if (!isLoggedIn) {
                  setAuthMode("login");
                  setShowAuthModal(true);
                }
              }}
              aria-label={isLoggedIn ? `Open profile menu for ${displayName}` : "Login or open profile menu"}
            >
              <span className="user-icon">
                <FaUserCircle className="header-action-icon" aria-hidden="true" />
              </span>

              {localStorage.getItem("userId") ? (
                <span className="user-menu-text">
                  <span className="user-name header-user-greeting">
                    Hello <span className="user-display-name">{displayName}</span>
                  </span>
                  {userType && (
                    userType === "Marketing Manager" ? (
                      <span className="desktop-dealer-link" onClick={() => navigate("/Dealer")}>
                        Become a Dealer
                      </span>
                    ) : (
                      <span className="desktop-dealer-link">
                        {userType}
                      </span>
                    )
                  )}
                </span>
              ) : (
                <span className="login-pill">
                  Login
                </span>
              )}
            </button>
          </Dropdown>

          {isLoggedIn && userType !== "SuperAdmin" && (
            <button
              type="button"
              className="header-icon-button header-cart-button"
              onClick={() => navigate("/cart")}
              aria-label={`Open cart with ${Number(count) || 0} items`}
            >
              <span className="header-icon-wrap">
                <FaShoppingCart className="header-action-icon" aria-hidden="true" />
                {Number(count) > 0 && (
                  <span className="header-badge" aria-hidden="true">
                    {formatBadgeCount(count)}
                  </span>
                )}
              </span>
            </button>
          )}
          <span className="price"></span>
        </div>

        <Modal
          title="My Wallet"
          open={walletModalOpen}
          onCancel={() => setWalletModalOpen(false)}
          footer={null}
          centered
        >
          <div style={{ textAlign: "center", fontSize: 18, padding: 20 }}>
            Available Balance
            <h2 style={{ color: "#005487" }}>₹ {Number(walletAmount || 0).toFixed(2)}</h2>
          </div>
        </Modal>

        {showAuthModal && (
          <AuthModal
            initialMode={authMode}
            onClose={() => setShowAuthModal(false)}
            onSuccess={handleAuthSuccess}
          />
        )}
      </header>
    </div>
  );
};

export default Header;
